module.exports = __webpack_public_path__ + "static/media/weather.830c90ff.png";